import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Modal } from 'react-bootstrap';

import RulesModal from "../main/mainElements/modals/RulesModal";

import Loggin from './homeModules/Loggin';
import Registration from './homeModules/Registration';
import RegistrationSuccess from './homeModules/RegistrationSuccess';
import RegistrationFinish from "./homeModules/RegistrationFinish";

import ResetPasswordRequest from './homeModules/ResetPasswordRequest';
import ResetPasswordRequestSuccess from './homeModules/ResetPasswordRequestSuccess';
import ResetPassword from './homeModules/ResetPassword';
import ResetPasswordSuccess from './homeModules/ResetPasswordSuccess';

export default function Home({ onSignIn }) {
    let [showCharta, setShowCharta] = useState(false);

    return (
        <div className="body">
            <div className="bg-dark p-2 d-none d-lg-flex justify-content-between">
                <h3 className="color-kuzel my-auto ms-2">
                    kuzel.online
                </h3>

                {/*<h3 className="color-kuzel my-auto ms-2">*/}
                {/*    <span className="d-bl d-sm-none">xs</span>*/}
                {/*    <span className="d-none d-sm-block d-md-none">sm</span>*/}
                {/*    <span className="d-none d-md-block d-lg-none">md</span>*/}
                {/*    <span className="d-none d-lg-block d-xl-none">lg</span>*/}
                {/*    <span className="d-none d-xl-block d-xxl-none">xl</span>*/}
                {/*    <span className="d-none d-xxl-block">xl</span>*/}
                {/*</h3>*/}

                <button className="btn-kuzel" onClick={() => setShowCharta(true)}>Kužeľová charta</button>
            </div>

            <div className="loginBody d-block d-lg-flex align-items-center mb-2">

                <div className="motto d-flex d-lg-none justify-content-center" style={{ marginBottom: '5rem' }}>
                    <div className="mottoContent top p-2 rounded">
                        <span className="mottoElement">Jeden <span>kužeľ</span></span>
                        <span className="mottoElement">Jedno <span>mesto</span></span>
                        <span className="mottoElement">Jedno <span>foto</span></span>
                    </div>
                </div>

                <div className="homePageContent mb-3 mx-auto ms-lg-3 col-11 col-md-11 col-xl-5 p-1 py-3 d-lg-flex px-2 px-lg-0 rounded">
                    <div className="login d-flex col-12 d-lg-none justify-content-center align-items-center border-bottom mb-3 pb-3">
                        <div className="d-block">
                            <Routes>
                                <Route index element={<Loggin onSignIn={() => onSignIn()} />} />
                                <Route path="registration" element={<Registration />} />
                                <Route path="registration-success" element={<RegistrationSuccess />} />
                                <Route path="registration-authorize" element={<RegistrationFinish />} />
                                <Route path="reset-password-request" element={<ResetPasswordRequest />} />
                                <Route path="reset-password-request-success" element={<ResetPasswordRequestSuccess />} />
                                <Route path="reset-password" element={<ResetPassword />} />
                                <Route path="reset-password-success" element={<ResetPasswordSuccess />} />
                            </Routes>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6 px-2">
                        <div className="motto row d-none d-lg-inline-block">
                            <div className="mottoContent">
                                <span className="mottoElement">Jeden <span>kužeľ</span></span>
                                <span className="mottoElement">Jedno <span>mesto</span></span>
                                <span className="mottoElement">Jedno <span>foto</span></span>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="color-kuzel d-none d-lg-block" style={{ fontSize: '0.8rem' }}>
                                Kužele sú neodmysliteľnou súčasťou našich miest a obcí. Je to symbol, bez ktorého by sme si nevedeli predstaviť naše okolie.
                                Milióny kužeľov zdobia naše cesty, parky či verejné priestranstvá. Sú tiché svedkyne našich ciest, ktoré nás vedú k novým dobrodružstvám.
                            </div>

                            <div className="color-kuzel d-none d-lg-block mt-1 mb-3" style={{ fontSize: '0.9rem' }}>
                                A preto ich všetci tak milujeme.
                            </div>
                            <div className="px-3 fs-5 mb-2">
                                Nájdi kužeľ, <span className="color-kuzel">odfoť</span> sa s ním, pridaj polohu a <span className="color-kuzel">zdieľaj</span> s ostatnými kužeľníkmi !
                            </div>

                            <div className="d-block d-lg-none mt-2">
                                <button className="btn-kuzel" onClick={() => setShowCharta(true)}>Pozri si kužeľovú chartu</button>
                            </div>

                        </div>
                    </div>

                    <div className="login d-none col-lg-6 d-lg-flex justify-content-center align-items-center border-start">
                        <div className="d-block">
                            <Routes>
                                <Route index element={<Loggin onSignIn={() => onSignIn()} />} />
                                <Route path="registration" element={<Registration />} />
                                <Route path="registration-success" element={<RegistrationSuccess />} />
                                <Route path="registration-authorize" element={<RegistrationFinish />} />
                                <Route path="reset-password-request" element={<ResetPasswordRequest />} />
                                <Route path="reset-password-request-success" element={<ResetPasswordRequestSuccess />} />
                                <Route path="reset-password" element={<ResetPassword />} />
                                <Route path="reset-password-success" element={<ResetPasswordSuccess />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                animation={false}
                show={showCharta}
                size='xl'
                fullscreen={true}
                scrollable="false"
                onHide={() => setShowCharta(false)}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100 color-kuzel">Kužeľová charta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RulesModal />
                </Modal.Body>
            </Modal>
        </div>
    );
}